import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-material-weight-icon',
  imports: [],
  template: `
    <svg [style.fill]="iconFill" [style.width.px]="width" [style.height.px]="height"  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="fi_10190675"><g clip-rule="evenodd" fill-rule="evenodd"><path d="m4.1516 9.27239c.33387-1.3355 1.53382-2.27239 2.91043-2.27239h9.87687c1.3766 0 2.5766.93689 2.9104 2.27239l2.5 10.00001c.4734 1.8934-.9587 3.7276-2.9104 3.7276h-14.87688c-1.95171 0-3.38378-1.8342-2.91042-3.7276zm2.91043-.27239c-.45887 0-.85886.3123-.97015.75746l-2.5 10.00004c-.15778.6311.31957 1.2425.97014 1.2425h14.87688c.6506 0 1.1279-.6114.9702-1.2425l-2.5-10.00004c-.1113-.44516-.5113-.75746-.9702-.75746z"></path><path d="m12 3c-1.1046 0-2 .89543-2 2s.8954 2 2 2 2-.89543 2-2-.8954-2-2-2zm-4 2c0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4s-1.7909 4-4 4c-2.20914 0-4-1.79086-4-4z"></path></g></svg>
  `,
  styles: `
    .icon-fill {
      fill: var(--p-bs-icon-color);
    }`,
  standalone: true
})
export class BsUserManagementIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
